import React, { Suspense, useState } from 'react';

import CompanyLogo from 'app/components/CommonStyled/CompanyLogo';
import { HomeBaseDrawerWrapper } from 'app/components/CommonStyled/HomeDrawers/HomeBaseDrawer/styled';
import PersonAvatar from 'app/components/CommonStyled/PersonAvatar';
import SideDrawer from 'app/components/CommonStyled/SideDrawer';
import GlobalPersonDrawer from 'app/components/Drawers/GlobalPerson/GlobalPersonDrawer';
import { HeartIcon } from 'app/components/shared/icons';
import dayjs from 'dayjs';
import useBehavioral from 'hooks/useBehavioral';

import {
  ShareBarLikeDrawerPersonCompany,
  ShareBarLikeDrawerPersonCompanyContainer,
  ShareBarLikeDrawerPersonDate,
  ShareBarLikeDrawerPersonInformationContainer,
  ShareBarLikeDrawerPersonName,
  ShareBarLikeDrawerPersonNameContainer,
  ShareBarLikeDrawerPersonWrapper,
} from './styled';

export interface IShareBarLikeDrawerPerson {
  datetime: string;
  person: {
    full_name: string;
    avatar: string;
    slug: string;
    uuid: string;
  };
  company: {
    slug: string;
    name: string;
  };
}

interface ShareBarLikeDrawerPersonProps {
  reaction: IShareBarLikeDrawerPerson;
  setGlobalDrawer: React.Dispatch<React.SetStateAction<{ slug: string; show: boolean }>>;
}

export default function ShareBarLikeDrawerPerson({
  reaction,
  setGlobalDrawer,
}: Readonly<ShareBarLikeDrawerPersonProps>) {
  const reactionsViewProfileClickedBehavioral = useBehavioral('REACTIONS_VIEW_PROFILE_CLICKED');
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  dayjs.extend(require('dayjs/plugin/relativeTime'));

  const handlePillClick = () => {
    reactionsViewProfileClickedBehavioral({
      related_object_uuid: reaction.person.slug,
    });
    setGlobalDrawer({ slug: reaction.person.slug, show: true });
  };

  return (
    <>
      <ShareBarLikeDrawerPersonWrapper onClick={handlePillClick}>
        <ShareBarLikeDrawerPersonInformationContainer>
          <HeartIcon
            width={16}
            height={16}
            fill="var(--color-data-passion-foreground)"
            borderColor="var(--color-data-passion-foreground)"
          />
          <PersonAvatar
            avatar={reaction.person.avatar}
            name={reaction.person.full_name.split(' ')[0]}
            lastName={reaction.person.full_name.split(' ')[1]}
            size={24}
            highlighted
          />
          <ShareBarLikeDrawerPersonNameContainer>
            <ShareBarLikeDrawerPersonName>
              {reaction.person.full_name}{' '}
            </ShareBarLikeDrawerPersonName>
            <ShareBarLikeDrawerPersonDate>
              {dayjs().to(dayjs(reaction.datetime))}
            </ShareBarLikeDrawerPersonDate>
          </ShareBarLikeDrawerPersonNameContainer>
        </ShareBarLikeDrawerPersonInformationContainer>
        <ShareBarLikeDrawerPersonCompanyContainer>
          <ShareBarLikeDrawerPersonCompany>
            {reaction?.company.name}
          </ShareBarLikeDrawerPersonCompany>
          <CompanyLogo slug={reaction?.company.slug} size={24} />
        </ShareBarLikeDrawerPersonCompanyContainer>
      </ShareBarLikeDrawerPersonWrapper>
      {showDrawer ? (
        <Suspense fallback={<HomeBaseDrawerWrapper />}>
          <GlobalPersonDrawer
            slug={reaction.person.slug}
            backToListAction={() => setShowDrawer(false)}
            comingFromList
          />
        </Suspense>
      ) : null}
    </>
  );
}
